import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AssetsService } from "../assets.service";
import { MessagesService } from "../../messages.service";
import * as XLSX from 'xlsx';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-movements-auditory',
  templateUrl: './movement-auditory.component.html',
  styleUrls: ['./movement-auditory.component.css']
})
export class MovementsAuditoryComponent implements OnInit {

    /*Filtros */
    public movementsSearchCriteria: any;
    public locations: any[];
    public movementTypes: any[];
    
    public dropdownSettings = {
        singleSelection: true,
        text: 'Seleccione',
        enableSearchFilter: true,
        enableFilterSelectAll: false,
        searchPlaceholderText: 'Buscar',
        showCheckbox: true,
        noDataLabel: 'Sin registros'
    };
    
    // see original project for full list of options
    // can also be setup using the config service to apply to multiple pickers
    public drpOptions: any = {
        locale: { format: 'DD/MM/YYYY', cancelLabel: 'Limpiar', applyLabel: 'Aceptar', customRangeLabel: 'Otro'  },
        alwaysShowCalendars: false,
        maxDate: new Date(),
        opens: "left",
        ranges: {
           'Hoy': [moment(), moment()],
           'Ayer': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
           'Últimos 7 días': [moment().subtract(6, 'days'), moment()],
           'Últimos 30 días': [moment().subtract(29, 'days'), moment()],
           'Este mes': [moment().startOf('month'), moment().endOf('month')],
           'El último mes': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        },
        autoUpdateInput: false,
        
    };

    /*Procesamiento*/
    public countFilters: Number;
    public loadingFilters: Boolean;
    public loadingResults: Boolean;

    /*Respuesta*/
    public isFiltered: Boolean;
    public filteredDate: Date;
    public page: number = 1;
    public total: number = 0;
    public movements: any[];

    constructor(private assetsService: AssetsService, private router: Router, private route: ActivatedRoute, private messagesService: MessagesService) { }

    ngOnInit() {
        this.movementsSearchCriteria = {
            "locationId": null,
            "movementCode": null,
            "dateFrom": null,
            "dateTo": null
        };
        this.initLoading();
        //Ver si hay que autocompletar con filtros de la navegación
        this.isFiltered = false;
        this.filteredDate = null;
        this.movements = [];
        if (this.route.snapshot.queryParamMap.get('autosearch')) {
            this.search();
        }
    }

    private initLoading() {
        this.countFilters = 2;
        this.loadingFilters = true;
        this.loadLocations();
        this.loadMovementTypes();
    }
    
    loadLocations() {
        this.assetsService.getLocations(null).subscribe(
            data => { 
                this.locations = data.map(l => ({ id: l.id, itemName: l.description }));
                this.movementsSearchCriteria.locationId = this.locations.filter(x=> x.id == this.route.snapshot.queryParamMap.get('location'));
                this.checkLoading(); 
            },
            error => { this.checkLoading(); this.locations = []; this.checkError(error, 'Ha ocurrido un error al cargar las ubicaciones') }
        );
    }

    loadMovementTypes() {
        this.assetsService.getMovementTypes().subscribe(
            data => { this.checkLoading(); this.movementTypes = data.map(l => ({ id: l.code, itemName: l.code + ' - ' + l.description })); },
            error => { this.checkLoading(); this.movementTypes = []; this.checkError(error, 'Ha ocurrido un error al cargar los tipos de movimientos') }
        );
    }

    private checkLoading() {
        this.countFilters = (this.countFilters.valueOf() - 1);
        if (this.countFilters == 0) {
            this.loadingFilters = false;
        }
    }

    private checkError(error: any, defaultMessage: string) {
        this.messagesService.checkError(error, defaultMessage);
    }

    public search(): void {
        let searchCriteria = {
            "locationId":  (this.movementsSearchCriteria.locationId && this.movementsSearchCriteria.locationId[0]) ? this.movementsSearchCriteria.locationId[0].id : null,
            "movementType": (this.movementsSearchCriteria.movementCode && this.movementsSearchCriteria.movementCode[0]) ? this.movementsSearchCriteria.movementCode[0].id : null,
            "dateFrom": this.movementsSearchCriteria.dateFrom,
            "dateTo": this.movementsSearchCriteria.dateTo
        };
        this.isFiltered = true;
        this.loadingResults = true;
        this.assetsService.getMovements(searchCriteria).subscribe(
            data => { this.loadingResults = false; this.movements = data; this.page = 1; this.filteredDate = new Date(); },
            error => { this.loadingResults = false; this.checkError(error, 'Ha ocurrido un error al buscar los movimientos'); }
        );
    }

    public download(): void {
        this.loadingResults = true;
        let exportable = new Array();
        let parent = this;
        exportable.push(["Tipo","#Referencia", "Ubicación", "Fecha", "Usuario", "Llenos", "Usados", "Vacios"]);
        this.movements.forEach(function (mov) {
            exportable.push(
             [  mov.movementDescription,
                mov.batchId,
                mov.locationName,
                moment(mov.createdDate).format('YYYY-MM-DD H:mm'),
                mov.createdBy,
                parent.getMovCount(mov,'F'),
                parent.getMovCount(mov,'U'),
                parent.getMovCount(mov,'E')
             ]   
            );
        });
        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(exportable);
        const wb: XLSX.WorkBook = { Sheets: { 'Sin ubicación': ws }, SheetNames: ['Sin ubicación'] };
        XLSX.writeFile(wb, 'Movimientos_' + moment(this.filteredDate).format('YYYY-MM-DD_H:mm') + '.xls', { bookType: 'xls', type: 'buffer' });
            
        this.loadingResults = false;
    }
    
    public selectedDate(value: any, datepicker?: any) {
        
        this.movementsSearchCriteria.dateFrom = value.start;
        this.movementsSearchCriteria.dateTo = value.end;

    }
    
    public calendarCanceled(e:any) {
        this.movementsSearchCriteria.dateFrom =null;
        this.movementsSearchCriteria.dateTo = null;
    }

    public getMovIcon(mov:any) {
        if (mov.movementType == 'D') {
            return 'fa-truck';
            
        }
        if (mov.movementType == 'M') {
            return 'fa-arrows'
            
        }
        if (mov.movementType == 'C') {
            return 'fa-barcode';
            
        }
        return '';
    }
    
    public getMovColor(mov:any) {
        return 'mov-'+ mov.movementType; 
    }
    
    public getMovCount(mov:any, status:string) {
        for (let sq of mov.statusQuantity) {
            if (sq.concept == status) {
                return sq.value;    
            }
        }
        return null;    
    }
    
}
